<template>
    <main-content>
        <div v-if="status !== 'loading'">
            <notification-form
                    v-if="form_data.is_email_verified"
                    :form_data="form_data"
                    :submit="submit"
            >
            </notification-form>
            <kt-panel v-else>
                <kt-panel-body>
                    <p class="font-weight-bolder text-center" :style="{fontSize: '15px'}">
                        {{ $t('message.email_not_verified') }}
                        <router-link
                                class="btn btn-brand d-block w-25 text-center align-content-center mx-auto mt-3"
                                to="/profile/update"> {{ $t('verify_change_email') }}</router-link>
                    </p>
                </kt-panel-body>
            </kt-panel>
        </div>
    </main-content>
</template>

<script>
    import mainContent from '@/components/main-content'
    import {mapGetters} from "vuex"
    import $ from "jquery"
    import { KTApp } from '@/plugins/core/app'
    import { notificationService } from '@/common/api.service'
    import notificationForm from './components/form'

    export default {
        name: "NotificationGet",

        components: {
            'main-content': mainContent,
            'notification-form': notificationForm
        },
        computed: {
            ...mapGetters('notification', [
                'form_data', 'status'
            ]),
        },
        beforeRouteEnter (to, from, next) {
            next(vm => {
                vm.$store.dispatch('notification/fetch')
            })
        },
        methods: {
            submit(e) {
                let form = $('#settings_form')
                let btn = $('#submit_btn')

                KTApp.progress(btn)

                let params = this.$store.getters['notification/form_data']

                notificationService.update(params).then(response => {
                    this.showMsg(form, 'success', response.data.message)
                }).catch(({response}) => {
                    this.showMsg(form, 'danger', response.data.message)
                })
                    .finally(() => {
                            KTApp.unprogress(btn)
                        }
                    )
            },
        },
    }
</script>

<style scoped>

</style>
